export default {"src":"/_next/static/media/ticket-green-46x46.de34aaf2.svg","height":19,"width":14};